export default __webpack_public_path__ + "static/media/addi2.f7b730ac.jpg";